import React from 'react';
import ReactDOM from 'react-dom';
import Toast from './ToastItem';

class ToastManager {
  TOAST_CONTAINER_CLASS_NAME = 'toast-container-main';

  DEFAULT_PLACEMENT = 'bottom-center';

  DEFAULT_TYPE = 'info';

  TOAST_CONTAINER_DOM_OBJECTS = document.getElementsByClassName(this.TOAST_CONTAINER_CLASS_NAME);

  TOAST_CONTAINER_INITIAL_REF = this.TOAST_CONTAINER_DOM_OBJECTS[0] || null;

  toasts = [];

  containerRef = this.TOAST_CONTAINER_INITIAL_REF;

  constructor() {
    if (!this.TOAST_CONTAINER_DOM_OBJECTS.length) {
      this.appendToastContainerToDOM();
    }
  }

  appendToastContainerToDOM() {
    const body = document.getElementsByTagName('body')[0];
    const toastContainer = document.createElement('div');
    toastContainer.className = this.TOAST_CONTAINER_CLASS_NAME;
    body.insertAdjacentElement('beforeend', toastContainer);
    this.containerRef = toastContainer;
  }

  show(options) {
    const toastMessagePlacementClassName = options.placement || this.DEFAULT_PLACEMENT;
    this.containerRef.className = `${this.TOAST_CONTAINER_CLASS_NAME} ${toastMessagePlacementClassName}`;
    const toastId = Math.random().toString(36).substr(2, 9);
    const toast = {
      type: options.type || this.DEFAULT_TYPE,
      id: toastId,
      ...options, // If id is passed within options, it will overwrite the auto-generated one
      destroy: () => this.destroy(options.id ?? toastId),
    };

    this.toasts = [toast, ...this.toasts];
    this.render();
  }

  error(options) {
    this.show({ ...options, type: 'error' });
  }

  success(options) {
    this.show({ ...options, type: 'success' });
  }

  info(options) {
    this.show({ ...options, type: 'info' });
  }

  warning(options) {
    this.show({ ...options, type: 'warning' });
  }

  destroy(id) {
    this.toasts = this.toasts.filter((toast) => toast.id !== id);
    this.render();
  }

  render() {
    const toastsList = this.toasts.map((toastProps) => <Toast key={toastProps.id} {...toastProps} />);
    ReactDOM.render(toastsList, this.containerRef);
  }
}

export const toast = new ToastManager();
